module.exports = __webpack_public_path__ + "img/parents.7fbece3f.svg";